module.exports = __webpack_public_path__ + "static/media/skeleton-loader.6803c94e.gif";